import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const IdealMemberFormGridContainer = styled.div`
  display: grid;
  grid-row-gap: 3.125rem;
  max-width: 1110px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  @media screen and (max-width: ${layout.md}) {
    grid-row-gap: 1.5rem;
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  row-gap: 1.5rem;

  .cohost-ideal-member-form-description {
    max-width: 600px;
    margin: 0 auto;
  }

  @media screen and (max-width: ${layout.md}) {
    .cohost-ideal-member-form-description {
      font-weight: 400;
    }
  }
`;

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.625rem;
  width: 80%;
  margin: 0 auto;

  > div {
    width: 100%;
  }

  @media screen and (max-width: ${layout.md}) {
    row-gap: 1.5rem;
    width: 100%;

    .cohost-ideal-member-form-examples {
      font-weight: 400;
    }

    .ideal-members-input-container {
      padding: 0 1rem;

      .paper-airplane-button svg {
        width: 100%;
      }
    }
  }
`;
